import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchReleaseNotes, releaseNoteUpdated, selectReleaseNoteById, selectReleaseNotesError, selectReleaseNotesStatus } from "./releaseNotesSlice";
import Spinner from "../../components/Spinner";
import { useEffect } from "react";
import AddReleaseNoteForm from "./AddReleaseNoteForm";
import { selectCurrentUserAdmin } from "../currentUser/currentUserSlice";

const EditReleaseNotePage = () => {

    const dispatch = useDispatch();
    const releaseNotesStatus = useSelector(selectReleaseNotesStatus);
    const releaseNotesError = useSelector(selectReleaseNotesError);
    const isAdmin = useSelector(selectCurrentUserAdmin);

    useEffect(() => {
        if (releaseNotesStatus === 'idle') {
            dispatch(fetchReleaseNotes());
        }
    }, [releaseNotesStatus, dispatch]);

    const { itemId } = useParams();
    const item = useSelector(state => selectReleaseNoteById(state, itemId));

    return <>
        {releaseNotesStatus === 'loading' && <Spinner />}
        {releaseNotesStatus === 'failed' && <div>{releaseNotesError}</div>}
        {releaseNotesStatus === 'succeeded' && <div className="pagecontent">
            {!item && <h2>Item not found!</h2>}
            <ReleaseNoteDisplay releaseNote={item} />
            <br />
            <br />
            {isAdmin && <>
            <EditReleaseNoteForm item={item} />
            <br />
            <br />
            <AddReleaseNoteForm />
            </>}
        </div>}
    </>
}

const ReleaseNoteDisplay = ({ releaseNote }) => {
    const toolname = releaseNote.toolname;
    const releasenumber = releaseNote.releasenumber;
    const dateDisplay = releaseNote.dateDisplay;
    const releasedescription = releaseNote.releasedescription;
    if (dateDisplay === "prior to 2025") {
        let separatedReleaseDescription = releasedescription.replaceAll("   ", "  ").split("  ");
        return <div>
            <p><b>{toolname}</b> Release Notes prior to 2025</p>
            <div style={{ marginLeft: "24px" }} >
                <ul>
                    {separatedReleaseDescription.map((line, lineIndex) => {
                        return <li key={lineIndex}>{line}</li>
                    })}
                </ul>
            </div>
        </div>
    }
    return <div>
        <p><b>{toolname}</b> Release {releasenumber} ({dateDisplay}) {releasedescription}.</p>
    </div>
}

const EditReleaseNoteForm = ({ item }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    if (!item) {
        return <div>
            <h2>Item not found!</h2>
        </div>
    }

    const onSaveItemClicked = (e) => {
        e.preventDefault();
        const { elements } = e.currentTarget;
        const toolname = elements.releaseNoteToolname.value;
        const releasenumber = elements.releaseNoteReleasenumber.value;
        const releasedate = elements.releaseNoteReleasedate.value;
        const dateDisplay = elements.releaseNoteDateDisplay.value;
        const releasedescription = elements.releaseNoteReleasedescription.value;

        if (toolname && releasenumber && releasedescription) {
            const newReleaseNote = {
                id: item.id, toolname, releasenumber, releasedate, dateDisplay, releasedescription
            };
            dispatch(releaseNoteUpdated(newReleaseNote));
            navigate(`/releasenotes/${item.id}`);
        }
    }

    return <div>
        <h2>Edit Release Note</h2>
        <form onSubmit={onSaveItemClicked}>
            <label htmlFor="releaseNoteToolname">Tool Name</label>
            <input type="text" style={{ width: "700px" }} id="releaseNoteToolname" name="releaseNoteToolname"
                defaultValue={item.toolname} required />
            <br />
            <label htmlFor="releaseNoteReleasenumber">Release Number</label>
            <input type="text" id="releaseNoteReleasenumber" name="releaseNoteReleasenumber"
                defaultValue={item.releasenumber} required />
            <br />
            <label htmlFor="releaseNoteReleasedate">Date (YYYY-MM-DD)</label>
            <input type="text" id="releaseNoteReleasedate" name="releaseNoteReleasedate"
                defaultValue={item.releasedate} required />
            <br />
            <label htmlFor="releaseNoteDateDisplay">Date Display (Month D, YYYY)</label>
            <input type="text" id="releaseNoteDateDisplay" name="releaseNoteDateDisplay"
                defaultValue={item.dateDisplay} required />
            <br />
            <label htmlFor="releaseNoteReleasedescription">Description</label>
            <input type="text" style={{ width: "1700px" }} id="releaseNoteReleasedescription" name="releaseNoteReleasedescription"
                defaultValue={item.releasedescription} required />
            <br />
            <button>Save Release Note</button>
        </form>
    </div>
}

export { EditReleaseNotePage, ReleaseNoteDisplay };